import { injectPageComponentaContext } from "widgets/commonComponents/base/injectPageComponentaContext"
import { getImgAlt, isAriaHidden, getImgTitle, calculateAutomaticComponentaUrl } from "widgets/widgetsUtils"
import * as apiUrls from "config/apiUrls"
import { SimpleLinkRenderer } from "../../../../commonComponents/inline/hyperLink"
import { PageComponentaContext } from "widgets/interfaces"
import { removeHtmlTagsFromString } from "../../../../jsonSerializer/common/jsonHelperUtils"
import * as ReactDOM from "react-dom"
import * as ReactTooltip from "react-tooltip"

export interface GalhedAutoItemSlotProps {
    image?: any
    title: string
    roof: string
    link: string
    fallenDate: string
    fallenDetails: string
    subTitle?: string
    isVer2?: boolean
    isSubTitleVisible?: boolean
    articleId?: string
}

@injectPageComponentaContext()
export class GalhedItemSlot extends React.Component<GalhedAutoItemSlotProps & Partial<PageComponentaContext>, {}> {
    public render() {
        const { image, siteLayoutType, title, roof, link, fallenDate, fallenDetails, isVer2, isSubTitleVisible, subTitle, articleId } = this.props
        const subtitleText = isSubTitleVisible && subTitle ? removeHtmlTagsFromString(subTitle) : ""

        const isMobile = siteLayoutType === "mobileWeb";
        const imageSizes = isVer2
            ? (isMobile ? { w: 144, h: 256 } : { w: 84, h: 150 }) // mobile: Figma 88x156 * 640/390
            : { w: 92, h: 141 };
        const imageTitle = subtitleText ? undefined : getImgTitle(image)

        return (
            <SimpleLinkRenderer
                href={link}
                className={"slotView"}
                data-tip={subtitleText ? "galhed-subtitle" : undefined}
                data-for={subtitleText ? `${articleId}-subtitle-tooltip` : undefined}
            >
                <div className="imageArea">
                    <img
                        title={imageTitle}
                        alt={getImgAlt(image)}
                        width={imageSizes.w}
                        height={imageSizes.h}
                        aria-hidden={isAriaHidden(image)}
                        src={apiUrls.getImageUrl(image, imageSizes)}
                    />

                    {subtitleText && typeof document !== "undefined" && ReactDOM.createPortal(
                        <ReactTooltip id={`${articleId}-subtitle-tooltip`} className="galhedSubTitleTooltip" place="top" type="light" effect="solid">
                            {subtitleText}
                        </ReactTooltip>,
                        document.body
                    )}
                </div>

                <div className="textArea">

                    <div className="slotRoof">
                        {roof}
                    </div>
                    <div className="slotTitle">

                        {title}

                    </div>
                    <div className="specialDetails">
                        <div className="slotFallenDate">
                            {fallenDate}
                        </div>
                        <div className="slotFallenDetails">
                            {fallenDetails}
                        </div>
                    </div>
           
                </div>
            </SimpleLinkRenderer>
        )
    }
}